import { useId } from "react";
import { StepperInput } from "./StepperInput";
import {
  FieldPairAside,
  FieldPairRow,
  FormGroup,
  FormSection,
  HelpText,
  Input,
  Label,
  SectionTitle,
} from "./styles";

interface BedrockFieldsProps {
  accessKey: string;
  setAccessKey: (value: string) => void;
  secretKey: string;
  setSecretKey: (value: string) => void;
  region: string;
  setRegion: (value: string) => void;
  modelId: string;
  setModelId: (value: string) => void;
  maxTokens: string;
  setMaxTokens: (value: string) => void;
}

export function BedrockFields({
  accessKey,
  setAccessKey,
  secretKey,
  setSecretKey,
  region,
  setRegion,
  modelId,
  setModelId,
  maxTokens,
  setMaxTokens,
}: BedrockFieldsProps) {
  const accessKeyId = useId();
  const secretKeyId = useId();
  const regionId = useId();
  const modelFieldId = useId();
  const maxTokensId = useId();

  return (
    <FormSection>
      <SectionTitle>AWS Bedrock configuration</SectionTitle>

      <FormGroup>
        <Label htmlFor={accessKeyId}>Access key*</Label>
        <Input
          id={accessKeyId}
          type="password"
          value={accessKey}
          onChange={(e) => setAccessKey(e.target.value)}
          placeholder="AKIA..."
          required
        />
      </FormGroup>

      <FormGroup>
        <Label htmlFor={secretKeyId}>Secret key*</Label>
        <Input
          id={secretKeyId}
          type="password"
          value={secretKey}
          onChange={(e) => setSecretKey(e.target.value)}
          placeholder="Secret access key"
          required
        />
      </FormGroup>

      <FormGroup>
        <Label htmlFor={regionId}>Region</Label>
        <Input
          id={regionId}
          type="text"
          value={region}
          onChange={(e) => setRegion(e.target.value)}
          placeholder="eu-west-1"
        />
        <HelpText>Leave empty for default (eu-west-1).</HelpText>
      </FormGroup>

      {/* Model ID + Max tokens share one row per Figma 14063-32733: the model
          stretches, the tokens keep the fixed aside width. */}
      <FieldPairRow>
        <FormGroup>
          <Label htmlFor={modelFieldId}>Model ID</Label>
          <Input
            id={modelFieldId}
            type="text"
            value={modelId}
            onChange={(e) => setModelId(e.target.value)}
            placeholder="anthropic.claude-sonnet-4-6"
          />
          <HelpText>
            Leave empty for default (anthropic.claude-sonnet-4-6).
          </HelpText>
        </FormGroup>

        <FieldPairAside>
          <Label htmlFor={maxTokensId}>Max tokens</Label>
          <StepperInput
            id={maxTokensId}
            label="max tokens"
            value={maxTokens}
            onChange={setMaxTokens}
            placeholder="64000"
          />
          <HelpText>Leave empty for default (64000).</HelpText>
        </FieldPairAside>
      </FieldPairRow>
    </FormSection>
  );
}
